import type { FaireProductEntity } from "../../entity_types/product";

export const p_y5xhkuvyjq: FaireProductEntity = {
  token: "p_y5xhkuvyjq",
  type: "product",
  name: "Blue Ribbon Congratulations Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl: "https://cdn.faire.com/fastly/70cbd9e6590ca1bb5fd38c4528b96f05299d866ad0e7e8c2c8e89da569173096.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d65d52cc07c660a09d8dbf8acdeddd3fb160521658ba39149756364a3bc19400.jpeg",
    "https://cdn.faire.com/fastly/45fd0e1fb8da8713cb5c48176e4ea0cecf36658bda99d7c60435c5ce9ca76983.png"
  ],
  priceDollars: 3,
  description: "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:42.604Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
